import {Component, Input} from '@angular/core';

@Component({
  selector: 'ngx-ba-card',
  templateUrl: './baCard.html',
})
export class BaCardComponent {
  @Input() title: String;
  @Input() baCardClass: String;
  @Input() cardType: String;
}
